import { LocaleEnum } from 'shared/enums/locale-enum'

// TODO: remove
export const getCalculatedLanguage = (language: string): string => {
  let readableLanguage
  switch (language) {
    case LocaleEnum.JAPANESE: {
      readableLanguage = 'jp'
      break
    }
    default: {
      readableLanguage = language
    }
  }

  return readableLanguage.toUpperCase()
}
